<div class="modal-overlay" *ngIf="isOpen" (click)="onOverlayClick()">
    <div class="modal-container" (click)="stopProp($event)" [class]="{'alert-container': isAlert}">
        <div class="modal-header">
            <h3 class="modal-title">{{ title }}</h3>
            <button class="close-btn" (click)="onClose()">
              <fa-icon [icon]="icons.falTimes"></fa-icon>
            </button>
        </div>
        <div class="modal-content" [class.no-scroll]="!contentScrollable">
            <ng-content></ng-content>
        </div>
        <div class="modal-footer text-center" *ngIf="showFooter">
            <app-core-button label="Entendido" (click)="onClose()"></app-core-button>
        </div>
    </div>
</div>
